/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_NotesInputs */

const en_clients_field_notes = /** @type {(inputs: Clients_Field_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes / observations`)
};

const pt_br2_clients_field_notes = /** @type {(inputs: Clients_Field_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observações / notas`)
};

/**
* | output |
* | --- |
* | "Notes / observations" |
*
* @param {Clients_Field_NotesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_notes = /** @type {((inputs?: Clients_Field_NotesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_NotesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_notes(inputs)
	return pt_br2_clients_field_notes(inputs)
});